export enum FleetClassificationSource {
    Fleet = 'FLEET',
    Individual = 'INDIVIDUAL',
}